import { FC } from 'react';
import { FormTextField } from 'omakase';
import { OTHER_OPTION_VALUE } from '@tock/shared/utils/questionUtils';
import { Theme, css } from '@emotion/react';
import { core } from '@tock/coretypes';

interface QuestionOptionalTextFieldProps {
  value: string | string[];
  name: string;
  question: core.TicketTypeQuestion;
}

const additionalTextField = ({ spacing }: Theme) => css`
  margin-top: ${spacing(3)}px;
`;

export const QuestionOptionalTextField: FC<QuestionOptionalTextFieldProps> = ({
  value,
  name,
  question,
}) => {
  const isOtherSelected =
    typeof value === 'string' ? value === OTHER_OPTION_VALUE : value.includes(OTHER_OPTION_VALUE);

  if (question.allowOther && isOtherSelected) {
    return (
      <FormTextField
        name={`${name}.otherValue`}
        inputProps={{
          'aria-label': `${OTHER_OPTION_VALUE} response`,
          'data-testid': 'pre-visit-question-text-other',
        }}
      />
    );
  }

  const hasValue = typeof value === 'string' ? !!value : value.length > 0;

  if (!!question.additionalTextPrompt && hasValue) {
    return (
      <div css={additionalTextField}>
        <FormTextField
          name={`${name}.otherValue`}
          label={question.additionalTextPrompt}
          minRows={4}
          multiline
          inputProps={{
            'data-testid': 'pre-visit-question-text-additional',
          }}
        />
      </div>
    );
  }

  return null;
};
